var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _rect3, _rect4, _rect5, _rect6, _circle;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchDevice26Ports(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 23,
    viewBox: "0 0 229 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.498704,
    y: 0.863878,
    width: 227.583,
    height: 21.8354,
    fill: "#fff",
    stroke: "black",
    strokeWidth: 0.400241
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9541,
    y: 5.24156,
    width: 12.8061,
    height: 12.8061,
    fill: "#fff",
    stroke: "black",
    strokeWidth: 0.370593
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.438 5.05627H172.556V18.5074H203.438V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.556 5.05627H141.673V18.5074H172.556V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.673 5.05627H110.79V18.5074H141.673V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.733 5.05627H213.184V18.2329H220.733V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.381087,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.517 12.7427H173.928V16.6971H175.756V17.3789H176.213V17.9584H178.232V17.3789H178.689V16.6971H180.517V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.634 12.7427H143.045V16.6971H144.873V17.3789H145.33V17.9584H147.349V17.3789H147.806V16.6971H149.634V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.751 12.7427H112.162V16.6971H113.99V17.3789H114.447V17.9584H116.466V17.3789H116.923V16.6971H118.751V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.575 16.9978H173.928V17.6841H175.575V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.692 16.9978H143.045V17.6841H144.692V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.809 16.9978H112.162V17.6841H113.809V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.516 16.9978H179.143V17.6841H180.516V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.634 16.9978H148.261V17.6841H149.634V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.751 16.9978H117.378V17.6841H118.751V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.654 12.7427H181.203V16.6971H183.003V17.3789H183.453V17.9584H185.441V17.3789H185.891V16.6971H187.654V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.771 12.7427H150.32V16.6971H152.12V17.3789H152.57V17.9584H154.558V17.3789H155.008V16.6971H156.771V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.888 12.7427H119.437V16.6971H121.237V17.3789H121.687V17.9584H123.675V17.3789H124.125V16.6971H125.888V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M182.713 16.9978H181.203V17.6841H182.713V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.829 16.9978H150.32V17.6841H151.829V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.947 16.9978H119.437V17.6841H120.947V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M187.791 16.9978H186.281V17.6841H187.791V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.909 16.9978H155.399V17.6841H156.909V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.025 16.9978H124.516V17.6841H126.025V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.929 12.7427H188.478V16.6971H190.278V17.3789H190.728V17.9584H192.716V17.3789H193.166V16.6971H194.929V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.045 12.7427H157.594V16.6971H159.394V17.3789H159.844V17.9584H161.832V17.3789H162.282V16.6971H164.045V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.163 12.7427H126.712V16.6971H128.512V17.3789H128.962V17.9584H130.95V17.3789H131.4V16.6971H133.163V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M189.988 16.9978H188.478V17.6841H189.988V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M159.104 16.9978H157.594V17.6841H159.104V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M128.222 16.9978H126.712V17.6841H128.222V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.928 16.9978H193.418V17.6841H194.928V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M164.045 16.9978H162.536V17.6841H164.045V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M133.163 16.9978H131.653V17.6841H133.163V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.066 12.7427H195.615V16.6971H197.415V17.3789H197.828V17.9584H199.853V17.3789H200.266V16.6971H202.066V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M171.183 12.7427H164.731V16.6971H166.532V17.3789H166.944V17.9584H168.97V17.3789H169.382V16.6971H171.183V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.3 12.7427H133.849V16.6971H135.649V17.3789H136.062V17.9584H138.087V17.3789H138.499V16.6971H140.3V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M197.125 16.9978H195.615V17.6841H197.125V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.241 16.9978H164.731V17.6841H166.241V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.358 16.9978H133.849V17.6841H135.358V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M202.066 16.9978H200.556V17.6841H202.066V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.183 16.9978H169.673V17.6841H171.183V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.3 16.9978H138.79V17.6841H140.3V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M195.478 10.82L202.066 10.82L202.066 6.86555L200.238 6.86555L200.238 6.18375L199.781 6.18375L199.781 5.60423L197.763 5.60423L197.763 6.18375L197.306 6.18375L197.306 6.86555L195.478 6.86555L195.478 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M164.595 10.82L171.183 10.82L171.183 6.86555L169.355 6.86555L169.355 6.18375L168.898 6.18375L168.898 5.60423L166.88 5.60423L166.88 6.18375L166.423 6.18375L166.423 6.86555L164.595 6.86555L164.595 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M133.712 10.82L140.3 10.82L140.3 6.86555L138.472 6.86555L138.472 6.18375L138.015 6.18375L138.015 5.60423L135.997 5.60423L135.997 6.18375L135.54 6.18375L135.54 6.86555L133.712 6.86555L133.712 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M200.419 6.56635L202.066 6.56635L202.066 5.88007L200.419 5.88007L200.419 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M169.536 6.56635L171.183 6.56635L171.183 5.88007L169.536 5.88007L169.536 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M138.653 6.56635L140.3 6.56635L140.3 5.88007L138.653 5.88007L138.653 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M195.478 6.56635L196.85 6.56635L196.85 5.88007L195.478 5.88007L195.478 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M164.594 6.56635L165.967 6.56635L165.967 5.88007L164.594 5.88007L164.594 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.712 6.56635L135.085 6.56635L135.085 5.88007L133.712 5.88007L133.712 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M188.34 10.82L194.791 10.82L194.791 6.86555L192.991 6.86555L192.991 6.18375L192.541 6.18375L192.541 5.60423L190.553 5.60423L190.553 6.18375L190.103 6.18375L190.103 6.86555L188.34 6.86555L188.34 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M157.458 10.82L163.909 10.82L163.909 6.86555L162.108 6.86555L162.108 6.18375L161.658 6.18375L161.658 5.60423L159.67 5.60423L159.67 6.18375L159.22 6.18375L159.22 6.86555L157.458 6.86555L157.458 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M126.575 10.82L133.026 10.82L133.026 6.86555L131.226 6.86555L131.226 6.18375L130.776 6.18375L130.776 5.60423L128.788 5.60423L128.788 6.18375L128.338 6.18375L128.338 6.86555L126.575 6.86555L126.575 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M193.281 6.56635L194.791 6.56635L194.791 5.88007L193.281 5.88007L193.281 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M162.399 6.56635L163.909 6.56635L163.909 5.88007L162.399 5.88007L162.399 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M131.516 6.56635L133.026 6.56635L133.026 5.88007L131.516 5.88007L131.516 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M188.203 6.56635L189.713 6.56635L189.713 5.88007L188.203 5.88007L188.203 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M157.32 6.56635L158.83 6.56635L158.83 5.88007L157.32 5.88007L157.32 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M126.438 6.56635L127.948 6.56635L127.948 5.88007L126.438 5.88007L126.438 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M181.066 10.82L187.517 10.82L187.517 6.86555L185.717 6.86555L185.717 6.18375L185.266 6.18375L185.266 5.60423L183.279 5.60423L183.279 6.18375L182.829 6.18375L182.829 6.86555L181.066 6.86555L181.066 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M150.182 10.82L156.634 10.82L156.634 6.86555L154.833 6.86555L154.833 6.18375L154.383 6.18375L154.383 5.60423L152.395 5.60423L152.395 6.18375L151.945 6.18375L151.945 6.86555L150.182 6.86555L150.182 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M119.299 10.82L125.75 10.82L125.75 6.86555L123.95 6.86555L123.95 6.18375L123.5 6.18375L123.5 5.60423L121.512 5.60423L121.512 6.18375L121.062 6.18375L121.062 6.86555L119.299 6.86555L119.299 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M186.007 6.56635L187.517 6.56635L187.517 5.88007L186.007 5.88007L186.007 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M155.124 6.56635L156.634 6.56635L156.634 5.88007L155.124 5.88007L155.124 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M124.241 6.56635L125.75 6.56635L125.75 5.88007L124.241 5.88007L124.241 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M181.065 6.56635L182.575 6.56635L182.575 5.88007L181.065 5.88007L181.065 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M150.183 6.56635L151.692 6.56635L151.692 5.88007L150.183 5.88007L150.183 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M119.3 6.56635L120.809 6.56635L120.809 5.88007L119.3 5.88007L119.3 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M173.928 10.82L180.379 10.82L180.379 6.86555L178.579 6.86555L178.579 6.18375L178.167 6.18375L178.167 5.60423L176.141 5.60423L176.141 6.18375L175.729 6.18375L175.729 6.86555L173.928 6.86555L173.928 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M143.045 10.82L149.496 10.82L149.496 6.86555L147.696 6.86555L147.696 6.18375L147.283 6.18375L147.283 5.60423L145.258 5.60423L145.258 6.18375L144.846 6.18375L144.846 6.86555L143.045 6.86555L143.045 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M112.163 10.82L118.614 10.82L118.614 6.86555L116.814 6.86555L116.814 6.18375L116.401 6.18375L116.401 5.60423L114.376 5.60423L114.376 6.18375L113.963 6.18375L113.963 6.86555L112.163 6.86555L112.163 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 6.56635L180.379 6.56635L180.379 5.88007L178.87 5.88007L178.87 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M147.987 6.56635L149.496 6.56635L149.496 5.88007L147.987 5.88007L147.987 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M117.104 6.56635L118.614 6.56635L118.614 5.88007L117.104 5.88007L117.104 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M173.929 6.56635L175.439 6.56635L175.439 5.88007L173.929 5.88007L173.929 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M143.045 6.56635L144.555 6.56635L144.555 5.88007L143.045 5.88007L143.045 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M112.163 6.56635L113.672 6.56635L113.672 5.88007L112.163 5.88007L112.163 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M215.292 10.0658H213.527V13.0854H215.292V12.6737H218.429V13.0854H220.39V10.0658H218.429V10.4089H215.292V10.0658Z",
    stroke: "black",
    strokeWidth: 0.137257
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.625,
    y: 11.1635,
    width: 0.686284,
    height: 0.686284,
    stroke: "black",
    strokeWidth: 0.137257
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 218.468,
    y: 11.1635,
    width: 0.686284,
    height: 0.686284,
    stroke: "black",
    strokeWidth: 0.137257
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214.625,
    y: 7.86991,
    width: 4.80399,
    height: 0.686284,
    stroke: "black",
    strokeWidth: 0.137257
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214.625,
    y: 14.5949,
    width: 4.80399,
    height: 0.686284,
    stroke: "black",
    strokeWidth: 0.137257
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 223.615,
    cy: 21.1154,
    r: 0.480399,
    stroke: "black",
    strokeWidth: 0.137257
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDevice26Ports);
export default __webpack_public_path__ + "static/media/switch-device-26-ports.ac082d0aa9659dd1bcc53b6d8d702aa7.svg";
export { ForwardRef as ReactComponent };